import React from 'react';
import { Link } from 'react-router-dom';

const CardControlCapacitacion = ({ id_proyecto_ }) => {
  return (
    <div className="card-capacitacion rounded">
      <div className="content detalles-evento p-3">
        <Link
          className='btn btn-primary mt-4'
          to={`/gestion-sesiones/${id_proyecto_}`}
        >
          Ir a panel de control
        </Link>
      </div>
    </div>
  );
}
 
export default CardControlCapacitacion;